export const CampaignAdCustomizerAttribute = {
  parent: 'Campaign',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Campaign AdCustomizer Attribute',
    },
    AdCustomizerAttributeValue: {
      'bulk-upload-header': 'AdCustomizer AttributeValue',
    },
  },
};
